<template>
<div class="aside__sticky" id="aside-sticky">
    <div class="nav nav--city" v-if="!isLoad && (sections.length>0 ||  sectionsLock.length>0)">
        <div class="nav-wrapper">
            <ul class="nav-list">
                <li class="nav-list-item" v-for="(cat, index) in sectionsLock" :key="cat.id" @click="closeRuleDetail(cat.id)">
                    <router-link v-if="popups.addRule.show && user.access_rights.is_owner || !popups.addRule.show" :href="'/rules/sid'+activeTopSection+'/sub'+cat.id+'/'" :to="'/sid'+activeTopSection+'/sub'+cat.id+'/'" class="nav-list-item-link"   :class="{active: cat.id == activeSection, 'can-hover': cat.id == activeSection && hoverClass, 'current': cat.id == rule.section }">
                        <div class="update-notify" v-if="!isEditing && cat.updated && cat.id != activeSection"></div>
                        <span class="cat-name">{{ cat.name }}</span>
                        <span class="i-wrapper" style="filter: none;">
                            <div class="i i-lock6"></div>
                        </span>
                    </router-link>
                    <a v-else href="javascript:void(0)" class="nav-list-item-link">
                        <span class="cat-name">{{ cat.name }}</span>
                        <span class="i-wrapper showedLock" style="filter: none;">
                            <div class="i i-lock6"></div>
                        </span>
                    </a>
                </li>
            </ul>
            <draggable :forceFallback="true" :disabled="isDragDisabled"
                        element="ul"
                        @start="dragStart"
                        @end="dragSave"
                        @choose="dragChoose"
                        v-model="localSections"
                        :group="{ name: 'sections' }"
                        :move="dragStatus"
                        :animation="150"
                        :swapThreshold="0.5"
                        :dragClass="['nav-list-item-dragging']"
                        class="nav-list"
                        :filter="'.i-wrapper, .add-section, .chevron'"
                        
            >
                <div v-for="(cat, index) in localSections" class="nav-list-item-wrapper" :class="getSectionClasses(cat)" :id="'parent-section-'+cat.id" :key="cat.id">
                    <li class="nav-list-item" :key="cat.id" @click="closeRuleDetail(cat.id, true)" :id="'section-'+cat.id">
                        <router-link :href="'/rules/sid'+activeTopSection+'/sub'+cat.id+'/'" :to="!cat.sections ? '/sid'+activeTopSection+'/sub'+cat.id+'/' : ''" class="nav-list-item-link"   :class="{active: cat.id == activeSection, 'can-hover': cat.id == activeSection && hoverClass, 'current': cat.id == rule.section }">
                            <div class="update-notify" v-if="!isEditing && cat.updated && cat.id != activeSection"></div>
                            <span class="cat-name">{{ cat.name }}</span>
                            <span class="i-wrapper" @click.stop.prevent="openRuleCategory(cat)" v-if="!dragChoosen">
                                <span class="i i-pencil2"></span>
                                <span class="i i-pencil2-active"></span>
                            </span>
                            <div class="add-section" @click.stop.prevent="openRuleCategory(cat, true)"  v-if="(!cat.sections || cat.sections.length === 0) && !dragChoosen">
                                <span class="i i-plus8"></span>
                                <span class="i i-plus8-active"></span>
                            </div>
                            <div class="chevron" v-if="(cat.sections && cat.sections.length > 0)">
                                 <svg class="big-icon">
                                    <use xlink:href="@/assets/img/big-icons-sprite.svg#chevron"></use>
                                </svg>
                            </div>
                        </router-link>
                    </li>
                    <draggable :forceFallback="true" :disabled="isDragDisabled"
                                    element="ul"
                                    @start="dragStart"
                                    @end="dragSave"
                                    @choose="dragChoose"
                                    :group="{ name: 'sections'}"
                                    :move="dragStatus"
                                    v-model="cat.sections"
                                    :swapThreshold="0.7"
                                    :animation="150"
                                    :dragClass="['nav-list-item-dragging']"
                                    class="nav-list"
                                    :filter="'.i-wrapper, .add-section, .chevron'"
                                    v-if="cat.sections && (cat.sections.length > 0 || dragging)"
                        >
                            <li class="nav-list-item" v-for="(subCat, index) in cat.sections" :key="subCat.id" :id="'section-'+subCat.id" @click="closeRuleDetail(subCat.id)">
                                <router-link :href="'/rules/sid'+activeTopSection+'/sub'+subCat.id+'/'" :to="'/sid'+activeTopSection+'/sub'+subCat.id+'/'" class="nav-list-item-link"   :class="{active: subCat.id == activeSection, 'can-hover': subCat.id == activeSection && hoverClass, 'current': subCat.id == rule.section }">
                                    <div class="update-notify" v-if="!isEditing && subCat.updated && subCat.id != activeSection"></div>
                                    <span class="cat-name">{{ subCat.name }}</span>
                                    <span class="i-wrapper" @click.prevent="openRuleCategory(cat, true, true, subCat)" v-if="!dragChoosen">
                                        <span class="i i-pencil2"></span>
                                        <span class="i i-pencil2-active"></span>
                                    </span>
                                </router-link>
                            </li>
                    </draggable>
                    <div class="add-section --full-btn" @click="openRuleCategory(cat, true)" v-if="cat.sections && cat.sections.length > 0">
                        <span class="i i-plus8"></span>
                        <span class="i i-plus8-active"></span>
                    </div>
                </div>
            </draggable>
        </div>
    </div>
    <div class="add-section__wrap" v-if="(curTopSection.rights == 'W' || user.is_chef || user.access_rights.is_owner) && !popups.addRule.show">
        <div class="add-section" @click="openRuleCategory">
            <span class="i i-plus8"></span>
            <span class="i i-plus8-active"></span>
        </div>
    </div>
</div>
</template>

<script>
    import {mapState} from 'vuex';
    import draggable from '@/helpers/vuedraggable.js';

    export default {
        name: "RulesSections",
        components: {
            draggable
        },
        created() {},
        mounted() {
            this.fetchData();
            
        },
        data(){
            return {
                drag: false,
                disabled: false,
                hoverClass: false,
                dragging: false,
                dragChoosen: false,
                expandedSections: new Set(),
                localSections: [],
            }
        },
        computed: {
            ...mapState({
                isLoad: state => state.rules.isLoadSections,
                popups: state => state.popups.items,
                isSearch: state => state.rules.isSearch,
                sectionsLock: state => state.rules.sectionsLock,
                topSections: state => state.rules.topSections,
                user: state => state.users.user,
                deactivatedItems: state => state.rules.deactivatedItems,
                canDrag: state => state.rules.canDrag,
                writerRights: state => state.rules.writerRights,
                rule: state => state.rules.openedRule,
            }),
            isEditing() {
              return this.popups.addRule.show;
            },
            activeTopSection(){
                if(this.isSearch) return false;
                return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
            },
             getSectionClasses() {
                return (cat) => {
                    return {
                        '--has-subs': cat.sections && cat.sections.length > 0,
                        '--dragging': this.dragging,
                        'expanded': this.expandedSections.has(cat.id),
                    };
                };
            },
            activeSection() {
                if (this.isSearch) {
                    return false;
                }
                
                if (this.$route.params.subid) {
                    return this.$route.params.subid;
                }
                
                if (!this.sections.length) {
                    return null;
                }
                
                const firstSection = this.sections[0];
                return firstSection.sections && firstSection.sections.length > 0 
                    ? firstSection.sections[0].id 
                    : firstSection.id;
            },
            curTopSection (){
                for (let i in this.topSections) {
                    if(this.topSections[i].id == this.activeTopSection){
                        return this.topSections[i];
                    }
                }
                return {}
            },
            isDragDisabled() {
                return !this.canDrag || this.popups.addRule.show || !(this.user.access_rights.is_owner || this.curTopSection.rights == 'W' || this.user.is_chef);
            },
            sections() {
                return this.$store.getters['rules/getSections'];
            },
        },
        methods: {
             toggleExpandSection(id) {
                if (this.expandedSections.has(id)) {
                    this.expandedSections.delete(id);
                } else {
                    this.expandedSections.add(id);
                }
                this.$forceUpdate();
            },
            
            expandParentSection(id) {
                const sectId = `section-${id}`;
                if (!document.getElementById(sectId)) {
                    return;
                }
                const sect = document.getElementById(sectId);
                const wrapper = sect.closest('.nav-list-item-wrapper');
                if (wrapper && wrapper.classList.contains('--has-subs')) {
                    const parentId = wrapper.id.replace('parent-section-', '');
                    this.expandedSections.add(parentId);
                    this.$forceUpdate();
                }
            },
            
            isSectionExpanded(id) {
                return this.expandedSections.has(id);
            },
            closeRuleDetail(id, isParentCat = false) {
                if(id == this.rule.section && this.popups.ruleDetail.show){
                    this.$emit('closedetail');
                }
                if (isParentCat) {
                    this.toggleExpandSection(id);
                }
            },
            removeItemById(list, id) {
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id == id) {
                        const [removed] = list.splice(i, 1);
                        return removed;
                    }
                    if (list[i].sections) {
                        const removed = this.removeItemById(list[i].sections, id);
                        if (removed) return removed;
                    }
                }
                return null;
            },
            insertItemAt(list, item, index) {
                list.splice(index, 0, item);
            },
            findItemById(list, id) {
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id == id) return list[i];
                    if (list[i].sections) {
                        const found = this.findItemById(list[i].sections, id);
                        if (found) return found;
                    }
                }
                return null;
            },
            dragSave: function (event) {
                document.body.classList.remove('is-choosing');

                this.dragChoosen = false;
                this.dragging = false;
                this.draggedItemOriginalIndex = null;
                this.draggedItemSubIndex = null;

                const draggedItemId = event.item.id.replace('parent-section-', '').replace('section-', '');
                let fromParentId = null;
                let toParentId = null;

                if (event.from && event.from.parentElement && event.from.parentElement.classList.contains('nav-list-item-wrapper')) {
                    fromParentId = event.from.parentElement.id.replace('parent-section-', '');
                }
                if (event.to && event.to.parentElement && event.to.parentElement.classList.contains('nav-list-item-wrapper')) {
                    toParentId = event.to.parentElement.id.replace('parent-section-', '');
                }
                const activeSectionId = toParentId ? +toParentId : this.activeTopSection;
                this.$store.commit('rules/setSections', { items: this.localSections });
                this.$store.dispatch('rules/setSectionsSort', { activeTopSection: activeSectionId, id: draggedItemId });
                this.drag = false;
            },
            dragStart: function (e) {
                this.dragging = true;
            },
           
            dragStatus: function (e) {
                this.drag = true;
                
                const draggedItem = e.draggedContext.element;
                
                const hasSubsections = draggedItem.sections && draggedItem.sections.length > 0;
                
                const targetLevel = this.getTargetNestingLevel(e.to);
                if (hasSubsections && targetLevel >= 2) {
                    return false;
                }
                
                return true;
            },

            getTargetNestingLevel(targetElement) {
                if (!targetElement) return 1;
                
                const parentWrapper = targetElement.closest('.nav-list-item-wrapper');
                if (parentWrapper && parentWrapper.classList.contains('--has-subs')) {
                    return targetElement.closest('.nav-list-item-wrapper') ? 2 : 1;
                }
                
                return 1;
            },
            dragChoose(e) {
                this.dragChoosen = true;

                document.body.classList.add('is-choosing');

                const onMouseUp = () => {
                    if (!this.dragging) {
                    this.dragChoosen = false;
                    }

                    document.body.classList.remove('is-choosing');
                    window.removeEventListener('mouseup', onMouseUp);
                };

                window.addEventListener('mouseup', onMouseUp);
            },

            fetchData () {
                this.expandedSections.clear()
                this.$store.dispatch('rules/getSections', {id: this.activeTopSection}).then(()=>{
                    this.expandParentSection(this.activeSection);
                })
            },
            openRuleCategory: function (cat, isSubNew = false, isSubEdit = false, subCat) {
                if (!isSubNew) {
                    this.$store.commit('rules/setEditSection', cat);
                } else if( isSubEdit) {
                    this.$store.commit('rules/setEditSection', subCat);
                    this.$store.commit('rules/setNewSubSectionLocation', cat);
                } else {
                    this.$store.commit('rules/setNewSubSectionLocation', cat);
                }
                this.$store.dispatch('popups/open', {name: this.popups.ruleCategory.name});
            },
            onSubSectionChange(parentCat) {
                this.$store.commit('rules/updateSubSections', {
                parentId: parentCat.id,
                newSubSections: [...parentCat.sections]
                });
            },
        },
        watch: {
            '$route.params.id': 'fetchData',
            '$route.params.subid': function() {
                setTimeout(() => {
                    this.expandParentSection(this.activeSection);
                }, 500);
            },
            sections: {
                handler(val) {
                    this.localSections = JSON.parse(JSON.stringify(val)); // глубокая копия
                },
                immediate: true,
                deep: true
            },
        },
    }
</script>

<style scoped>
    .showedLock{
        display: block !important;
    }

</style>
